/// <reference path="../definitions/QueryTs.d.ts" />
/// <reference path="../definitions/QueryTs.Template.d.ts" />
/// <reference path="../definitions/QueryTs.SVG.d.ts" />
/// <reference path="../definitions/QueryTs.Touch.d.ts" />
/// <reference path="../definitions/QueryTs.Upload.d.ts" />


interface ISiteFilterModel {
    listGroup?: string;
    articleGroupId?: string;

    query?: string;
    listGroups?: string[];
    articleGroups?: string[];
    articleSorts?: string[];
    features?: { [key: string]: string[] };
    manufacturerSuppliers?: string[];
    index?: string[];
    baseColors?: string[];
    tags?: string[];
    articleHeight?: string[];
    articleWidth?: string[];
    price?: string[];
    locations?: string[];
    orderBy?: string;
    favorites?: boolean;
}
interface ISiteFilterResponse {
    filters: ISiteFilterItem[];
}
interface ISiteFilterItem {
    filterName: string;
    name: string;
    items: ISiteFilterItemValue[];
}
interface ISiteFilterItemValue {
    filterValue: string;
    name: string;
    count: number;
    childs: ISiteFilterItemValue[];
}
interface ISiteFilterColorItemValue
    extends ISiteFilterItemValue {
    
    colorName: string;
}
interface ISiteAssortmentConfig {
    currentDateTime: string;
    refreshDateTime: string;
    closeDateTime: string;
    defaultLayout: SiteLayout;
    defaultMobileLayout: SiteLayout;
    defaultOrderBy: string;
}

type SiteLayout = 'Line' | 'Small' | 'Medium' | 'Full';
type SiteResponses = 'Message' | 'Cart' | 'Favorites';
interface IPayloadResponse {

}
interface IResponse {
    type: SiteResponses;
    payLoad: IPayloadResponse
}
interface IMessagePayloadResponse
    extends IPayloadResponse {
    
    title?: string;
    message?: string;
    sort: SiteMessageSorts;
    timeOut?: number;
}
interface ICartPayloadResponse 
    extends IPayloadResponse {
    succeeded: boolean;
}
interface IFavoritesPayloadResponse 
    extends IPayloadResponse {
    succeeded: boolean;
}

class Site 
    extends QueryElement<HTMLElement> {
    
    private readonly _shoppingCart: SiteElementShoppingCart | null;
    private readonly _orderStatus: SiteElementOrderStatus | null;
    private readonly _favorites: SiteElementFavorites | null;
    private readonly _messages: SiteMessages;
    private _activePopup: SiteElementPopup | null;
    private _keyboard: SiteKeyboard;

    constructor(element: HTMLElement) {
        super(element);

        let shoppingCart = this.query(".shopping-cart").create<SiteElementShoppingCart, HTMLElement>(a => new SiteElementShoppingCart(a, this));
        let orderStatus = this.query(".order-status").create<SiteElementOrderStatus, HTMLElement>(a => new SiteElementOrderStatus(a, this));
        let favorites = this.query(".favorites").create<SiteElementFavorites, HTMLElement>(a => new SiteElementFavorites(a, this));
        let messages = this.query('#messages').create<SiteMessages, HTMLElement>(a => new SiteMessages(a));

        if (messages === null)
            throw "Default element(s) not found!"
        
        this._shoppingCart = shoppingCart;
        this._orderStatus = orderStatus;
        this._favorites = favorites;
        this._messages = messages;

        // Create other elements
        this.query(".element-carousel").createAll<SiteElementCarousel, HTMLElement>(a => new SiteElementCarousel(a));
        this.query(".element-search").createAll<SiteElementSearch, HTMLElement>(a => new SiteElementSearch(a));
        this.query(".element-upload").createAll<SiteElementUpload, HTMLElement>(a => new SiteElementUpload(a));
        this.query(".element-sticky").createAll<SiteElementSticky, HTMLElement>(a => new SiteElementSticky(a));
        this.query(".element-hover").createAll<SiteElementHover, HTMLElement>(a => new SiteElementHover(a));
        this.query(".element-hide").createAll<SiteElementHide, HTMLElement>(a => new SiteElementHide(a, this)); 
        this.query(".element-scroll").createAll<SiteElementScroll, HTMLElement>(a => new SiteElementScroll(a)); 
        this.query(".display-product").createAll<SiteElementProductStaticContainer, HTMLElement>(a => new SiteElementProductStaticContainer(a, this));

        // Create binds
        this.query(".bind").createAll<SiteBind, HTMLElement>(a => new SiteBind(a));

        // Create popups
        this._activePopup = null;

        this.query(".event-popup").all(a => {
            var href = a.getAttr("href");
            if (href && href.charAt(0) != '#')
                a.setAttr("href", `#${href}`);
        });
        this.query(".event-redirect").all(a => {
            a.on("click", e => {
                var href = a.getAttr("href");
                if (href) {
                    window.location.href = href.replace("%7B0%7D", encodeURIComponent(window.location.pathname))
                }
                e.stop();
            });
        });

        this._keyboard = new SiteKeyboard(this);

        window.addEventListener("hashchange", () => {
            this.openPopup(window.location.hash.substr(1));
        });
        if (window.location.hash)
            this.openPopup(window.location.hash.substr(1));
    }
    showHideConfidential() {
        if (this.containsClass("confidential-mode")) {
            this.removeClass("confidential-mode");
        } else {
            this.addClass("confidential-mode");
        }
    }
    addMessage(message: IMessagePayloadResponse) {
        var messageElement = new SiteMessage(message);
        this._messages.add(messageElement);
        return this;
    }
    openPopup(url: string) {
        if (this._activePopup != null)
            this._activePopup.remove();
        
        if (url == "")
            return;
        
        var popup = new SiteElementPopup(this)
            .appendTo(this);
        popup.request(url);
        this._activePopup = popup;
    }
    closePopup() {
        if (this._activePopup != null)
            this._activePopup.remove();
        
        this._activePopup = null;

        var url = window.location.href.split("#", 1);
        history.replaceState(
            {}, 
            "Geen idee", 
            url[0]);
    }
    static isMobile() {
        let body = QueryElement.get(document.body).position();
        if(body === null)
            return true;
        
        return body.width <= 768;
    }
    getFavorites() {
        return this._favorites;
    }
    getShoppingCart() {
        return this._shoppingCart;
    }
    eventAddedPreOrder() {
        this._shoppingCart?.reload();
        this._orderStatus?.reload();
    }
    async deleteItemCart(id: string, reload: boolean) {
        let request = new QueryRequest(
            `/Cart/Delete/${id}`, {
            contentType: 'json',
            method: 'get'
        });

        var response = await request.request();
        var jsonResponse: IResponse = await response.json();

        switch(jsonResponse.type)
        {
            case "Cart":
            {
                let payLoad = <ICartPayloadResponse>jsonResponse.payLoad;
                if (payLoad.succeeded)
                {          
                    if (reload == true)
                        window.location.reload();
                    else
                        this.eventAddedPreOrder();
                }
            }
            case "Message":
            {
                let payLoad = <IMessagePayloadResponse>jsonResponse.payLoad;
                this.addMessage(payLoad);
            }
        }
    }
    async deleteItemFavorite(id: string, reload: boolean) {
        let request = new QueryRequest(
            `/Favorites/Delete/${id}`, {
            contentType: 'json',
            method: 'get'
        });

        var response = await request.request();
        var jsonResponse: IResponse = await response.json();
        // refresh cards
        if (reload == true)
            window.location.reload();
        else
            this._favorites?.reload();
    }
    on<TEvent extends Event>(val: string, func: (e: TEvent) => any): (e: TEvent) => any {
        if (val == "scroll")
        {
            document.addEventListener("scroll", <(ev: Event) => any>func, false);
            return func;
        }
        return super.on(val, func);
    }
    
    resize() {
        
    }
}

class SiteAssortment
    extends Site {

    private readonly _filters: ISiteFilter[];
    private readonly _product: SiteElementProduct;
    private readonly _navigation: SiteNavigation;

    private readonly _refreshDateTime: Date;
    private readonly _closeDateTime: Date;
    private readonly _dateTimeOffset: number;

    private readonly _defaultLayout: SiteLayout;
    private readonly _defaultMobileLayout: SiteLayout;
    private readonly _defaultOrderBy: string;

    constructor(element: HTMLElement, config: ISiteAssortmentConfig) {
        super(element);

        this._dateTimeOffset = new Date().getTime() - new Date(config.currentDateTime).getTime();
        this._refreshDateTime = new Date(config.refreshDateTime);
        this._closeDateTime = new Date(config.closeDateTime);

        this._defaultLayout = config.defaultLayout;
        this._defaultMobileLayout = config.defaultMobileLayout;
        this._defaultOrderBy = config.defaultOrderBy;
        
        // Set refresh timer
        let refreshIn = this._refreshDateTime.getTime() - new Date().getTime() + this._dateTimeOffset;
        
        // Protect against overflowing INT32 from setTimeout, which will refresh directly
        if (refreshIn < Math.pow(2,31) - 1 && refreshIn > 0)
            window.setTimeout(() => location.reload(), refreshIn);
        
        this._navigation = new SiteNavigation();
        
        // Setup filters
        this._filters = [];
        this._filters.push(new SiteFilterSingleValue("ListGroup", ""));
        this._filters.push(new SiteFilterSingleValue("Favorites", ""));
        this._filters = this._filters.concat(this.query(".element-filter-array").createAll<SiteElementFilter, HTMLElement>(a => new SiteElementFilterArray(a, this)));
        this._filters = this._filters.concat(this.query(".element-filter-single").createAll<SiteElementFilter, HTMLElement>(a => new SiteElementFilterSingle(a, this)));
        this.query(".element-filter-clear").createAll<SiteElementFilterClear, HTMLElement>(a => new SiteElementFilterClear(a, this));
        
        var filterModel: any = this._navigation.parseUrl(this.getFilterModel(), window.location.pathname);
        
        for(let filter of this._filters) {

            var filterName = QueryJSON.toCamelCase(filter.getName());
            
            if (filter instanceof SiteElementFilterArray) {
                var values = filterModel[filterName] as string[];
                if (values) {
                    for (let value of values) {
                        filter.addValue(value);
                    }
                }
            }
            else if (filter instanceof SiteElementFilterSingle || filter instanceof SiteFilterSingleValue) {
                var value = filterModel[filterName] as string;
                if (value) {
                    filter.setValue(value);
                }
            }
        }
        

        // Setup extra elements
        this.query(".element-layout").createAll<SiteElementLayout, HTMLElement>(a => new SiteElementLayout(a, this));
        this.query(".element-close").createAll<SiteElementClose, HTMLElement>(a => new SiteElementClose(a, new Date((this._closeDateTime.getTime() + this._dateTimeOffset) / 1000)));
        var product = this.query(".element-product").create<SiteElementProduct, HTMLElement>(a => new SiteElementProduct(a, this, filterModel));

        if (product == null)
            throw "Element(s) not found!";
    
        this._product = product;

        this.setFilters(filterModel, []);
    }

    getFilterModel() : ISiteFilterModel {
        let filterModel: any = {};
        for(var filter of this._filters)
        {
            const filterName = QueryJSON.toCamelCase(filter.getName());

            let currTarget = filterModel;
            const parts = filterName.split('.');
            const last = parts.pop() ?? "";
        
            // Navigate to the deep property
            for (const part of parts) {
                // Initialize the nested object if it doesn't exist
                if (!(part in currTarget)) {
                    currTarget[part] = {};
                }
                currTarget = currTarget[part];
            }

            if (filter instanceof SiteElementFilterArray)
                currTarget[last] = filter.getValues();
            else if (filter instanceof SiteElementFilterSingle || filter instanceof SiteFilterSingleValue)
                currTarget[last] = filter.getValue();
        }

        if (!filterModel.orderBy)
            filterModel.orderBy = this._defaultOrderBy;

        return filterModel as ISiteFilterModel;
    }
    clearFilterModel() {
        for(var filter of this._filters)
        {
            if (filter instanceof SiteElementFilterArray)
                filter.removeValues();
            else if (filter instanceof SiteElementFilterSingle || filter instanceof SiteFilterSingleValue)
                filter.removeValue();
        }
    }
    resize() {
        this._product.resize();
    }
    getLayout() {
        return this._product;
    }
    setLayout(layout: string) {
        this._product.setLayout(layout);
    }
    async updateFilterModel(filter: ISiteFilter | null, name: string[]) {
        if (this._product == null)
            return;
        
        // Set other (same) filters to right values:
        if (filter != null)
        {
            var setFilterName = filter.getName();
            for(var currFilter of this._filters)
            {
                var filterName = currFilter.getName();

                if (setFilterName == filterName)
                {
                    if (currFilter instanceof SiteElementFilterArray && filter instanceof SiteElementFilterArray)
                    {
                        currFilter.setValues(filter.getValues());
                    }
                    else if (currFilter instanceof SiteElementFilterSingle && filter instanceof SiteElementFilterSingle)
                    {
                        currFilter.setValue(filter.getValue());
                    }
                }
            }
        }
        
        var filterModel = this.getFilterModel();

        var url = this._navigation.getUrl(filterModel);
        history.replaceState(
            {}, 
            "Geen idee", 
            url);

        this.setFilters(filterModel, name);
        this._product.setFilterModel(filterModel);
    }
    private async setFilters(filters: ISiteFilterModel, skipName: string[]) {

        let request = new QueryRequest('/Assortment/Filters', {
            contentType: 'json',
            method: 'post',
            data: JSON.stringify(filters)
        });

        var response = await request.request();
        var jsonResponse: ISiteFilterResponse = await response.json();

        for(var filter of this._filters) {
            var filterName = filter.getName();

            if (skipName.indexOf(filterName) === -1) {
                var item = jsonResponse.filters
                    .filter(a => a.filterName == filterName);
                filter.setContent(item[0]);
            }
        }
    }
    async reloadFilters() {
        await this.setFilters(this.getFilterModel(), []);
    }

    getDefaultLayout() {
        return this._defaultLayout;
    }
    getDefaultMobileLayout() {
        return this._defaultMobileLayout;
    }
}

interface Event {
    stop(): void;
}
interface Array<T> {
    remove(item: T): T[];
}
Event.prototype.stop = function() {
    this.preventDefault();
    this.stopPropagation();
    this.stopImmediatePropagation();
}
Array.prototype.remove = function(item: any) {
    let ax: number;
    while ((ax = this.indexOf(item)) !== -1) {
        this.splice(ax, 1);
    }
    return this;
};
function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}